import { Component, OnInit } from '@angular/core';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';

@Component({
  selector: 'app-tenant-identity-provider',
  templateUrl: './tenant-identity-provider.component.html',
  styleUrls: ['./tenant-identity-provider.component.scss']
})
export class TenantIdentityProviderComponent implements OnInit {

  constructor(private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {
  }

}
